module.exports = __webpack_public_path__ + "aaa671a4d4032c4d52ef3fbb7c8bf562.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-main-1080.webp
// module id = 452
// module chunks = 0